import { css } from 'emotion';

export const pageContent = css({
  '& > *': {
    marginBottom: '2.5em',
  },
});
